// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + "f5b3e7743f88e65cf95c" + ".chunk.js";
};